"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sanjiang = require("@/api/sanjiang");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ImmediateActivityDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      merchantLoading: false,
      gunLoading: false,
      form: {
        sort: '',
        name: '',
        startTime: '',
        endTime: '',
        priority: 0,
        productCodes: [],
        type: 1,
        // 活动类型：1-每升优惠，2-总金额优惠
        stationCodes: [],
        stationNames: [],
        remark: '',
        rules: [{
          ruleName: '',
          ruleType: 1,
          // 时间类型：1-自然日，2-自然周
          weekStart: null,
          // 周开始
          weekEnd: null,
          // 周结束
          startTime: null,
          // 规则开始时间
          endTime: null,
          // 规则结束时间
          condition: 0,
          // 优惠门槛（总金额优惠时使用）
          reward: 0,
          // 优惠内容（总金额优惠时使用）
          discount: 0 // 优惠金额（每升优惠时使用）
        }]
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }],
        priority: [{
          required: true,
          message: '请输入优先级',
          trigger: 'blur'
        }],
        productCodes: [{
          required: true,
          message: '请选择油品类型',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择活动类型',
          trigger: 'change'
        }],
        stationCodes: [{
          required: true,
          message: '请选择加油站',
          trigger: 'change'
        }]
      },
      oilTypeOptions: [],
      merchantOptions: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.editData ? '编辑' : '新增';
    }
  },
  mounted: function mounted() {
    this.getMerchantList();
    this.getGunList();
  },
  watch: {
    visible: {
      handler: function handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initForm();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取商家列表
    getMerchantList: function () {
      var _getMerchantList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var keyword,
          res,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              keyword = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              _context.p = 1;
              this.merchantLoading = true;
              _context.n = 2;
              return (0, _sanjiang.getStationList)({
                keyword: keyword
              });
            case 2:
              res = _context.v;
              console.log(res);
              this.merchantOptions = res || [];
              // if (response && response.data) {
              //   this.merchantOptions = response.data;
              // }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取商家列表失败:', _t);
              this.$message.error('获取商家列表失败');
              this.merchantOptions = [];
            case 4:
              _context.p = 4;
              this.merchantLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getMerchantList() {
        return _getMerchantList.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    // 搜索商家（带防抖）
    searchMerchants: function () {
      var timer = null;
      return function (keyword) {
        var _this = this;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          _this.getMerchantList(keyword);
        }, 1500); // 300ms防抖
      };
    }(),
    // 获取油品类型列表
    getGunList: function () {
      var _getGunList2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var keyword,
          res,
          data,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              keyword = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              _context2.p = 1;
              this.gunLoading = true;
              _context2.n = 2;
              return (0, _sanjiang.getGunList)({
                keyword: keyword
              });
            case 2:
              res = _context2.v;
              console.log('油品类型响应:', res);

              // 处理不同的数据结构
              data = [];
              if (res) {
                if (Array.isArray(res)) {
                  data = res;
                } else if (res.data && Array.isArray(res.data)) {
                  data = res.data;
                } else if (res.list && Array.isArray(res.list)) {
                  data = res.list;
                }
              }

              // 转换为选择框需要的格式
              this.oilTypeOptions = data || [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('获取油品类型失败:', _t2);
              this.$message.error('获取油品类型失败');
              this.oilTypeOptions = [];
            case 4:
              _context2.p = 4;
              this.gunLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getGunList() {
        return _getGunList2.apply(this, arguments);
      }
      return getGunList;
    }(),
    // 搜索油品类型（带防抖）
    searchOilTypes: function () {
      var timer = null;
      return function (keyword) {
        var _this2 = this;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          _this2.getGunList(keyword);
        }, 1500); // 300ms防抖
      };
    }(),
    // 处理时间类型切换
    handleRuleTypeChange: function handleRuleTypeChange(value) {
      console.log('时间类型切换:', value);
      // 当切换到自然日时，清空自然周相关的字段
      if (value === 1) {
        this.form.rules[0].weekStart = null;
        this.form.rules[0].weekEnd = null;
        this.form.rules[0].startTime = null;
        this.form.rules[0].endTime = null;
      }
    },
    // 处理活动类型切换
    handleActivityTypeChange: function handleActivityTypeChange(value) {
      console.log('活动类型切换:', value);
      // 当切换到每升优惠时，清空总金额优惠相关字段
      if (value === 1) {
        this.form.rules[0].condition = 0;
        this.form.rules[0].reward = 0;
      }
      // 当切换到总金额优惠时，清空每升优惠相关字段
      else if (value === 2) {
        this.form.rules[0].discount = 0;
      }
    },
    // 处理加油站选择变化，同步更新stationNames
    handleStationChange: function handleStationChange(selectedCodes) {
      var _this3 = this;
      // 根据选中的id顺序，从merchantOptions中获取对应的name
      this.form.stationNames = selectedCodes.map(function (code) {
        var station = _this3.merchantOptions.find(function (item) {
          return item.id === code;
        });
        return station ? station.name : '';
      }).filter(function (name) {
        return name;
      }); // 过滤掉空值
    },
    // 初始化表单
    initForm: function initForm() {
      if (this.editData) {
        // 编辑模式，填充数据
        this.form = _objectSpread({}, this.editData);
        console.log(this.form, 'this.form');
      } else {
        // 新增模式，重置表单
        this.resetForm();
      }
    },
    // 重置表单
    resetForm: function resetForm() {
      var _this4 = this;
      this.form = {
        sort: '',
        name: '',
        startTime: '',
        endTime: '',
        priority: 0,
        productCodes: [],
        type: 1,
        stationCodes: [],
        stationNames: [],
        remark: '',
        rules: [_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
          ruleType: 1,
          ruleName: ''
        }, "ruleType", 1), "weekStart", null), "weekEnd", null), "startTime", null), "endTime", null), "condition", 0), "reward", 0), "discount", 0)]
      };
      this.$nextTick(function () {
        _this4.$refs.form && _this4.$refs.form.clearValidate();
      });
    },
    // 提交表单
    handleSubmit: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this5 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
                  var submitData, _t3;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.p = _context3.n) {
                      case 0:
                        if (!valid) {
                          _context3.n = 11;
                          break;
                        }
                        _this5.submitLoading = true;

                        // 处理表单数据
                        submitData = _objectSpread({}, _this5.form); // 根据活动类型清空不相关的字段
                        if (submitData.type === 1) {
                          // 每升优惠时，清空总金额优惠相关字段
                          submitData.rules[0].condition = 0;
                          submitData.rules[0].reward = 0;
                        } else if (submitData.type === 2) {
                          // 总金额优惠时，清空每升优惠相关字段
                          submitData.rules[0].discount = 0;
                        }

                        // 根据时间类型清空不相关的字段
                        if (submitData.rules[0].ruleType === 1) {
                          // 自然日时，清空自然周相关字段
                          submitData.rules[0].weekStart = null;
                          submitData.rules[0].weekEnd = null;
                          submitData.rules[0].startTime = null;
                          submitData.rules[0].endTime = null;
                        }
                        console.log('提交数据清理后:', submitData);
                        console.log('活动类型:', submitData.type);
                        console.log('时间类型:', submitData.rules[0].ruleType);

                        // 验证优惠规则
                        if (_this5.form.rules[0].ruleName) {
                          _context3.n = 1;
                          break;
                        }
                        _this5.$message.warning('请输入规则名称');
                        _this5.submitLoading = false;
                        return _context3.a(2);
                      case 1:
                        if (!(_this5.form.type === 2)) {
                          _context3.n = 3;
                          break;
                        }
                        if (!(_this5.form.rules[0].condition <= 0 || _this5.form.rules[0].reward <= 0)) {
                          _context3.n = 2;
                          break;
                        }
                        _this5.$message.warning('请完善优惠门槛和优惠内容设置');
                        _this5.submitLoading = false;
                        return _context3.a(2);
                      case 2:
                        _context3.n = 4;
                        break;
                      case 3:
                        if (!(_this5.form.type === 1)) {
                          _context3.n = 4;
                          break;
                        }
                        if (!(_this5.form.rules[0].discount <= 0)) {
                          _context3.n = 4;
                          break;
                        }
                        _this5.$message.warning('请设置优惠金额');
                        _this5.submitLoading = false;
                        return _context3.a(2);
                      case 4:
                        _context3.p = 4;
                        if (!_this5.editData) {
                          _context3.n = 6;
                          break;
                        }
                        _context3.n = 5;
                        return (0, _sanjiang.updateImmediateActivity)(_this5.editData.id, submitData);
                      case 5:
                        _this5.$message.success('编辑成功');
                        _context3.n = 8;
                        break;
                      case 6:
                        _context3.n = 7;
                        return (0, _sanjiang.createImmediateActivity)(submitData);
                      case 7:
                        _this5.$message.success('新增成功');
                      case 8:
                        _this5.$emit('success');
                        _this5.handleClose();
                        _context3.n = 10;
                        break;
                      case 9:
                        _context3.p = 9;
                        _t3 = _context3.v;
                        console.error('提交失败:', _t3);
                        _this5.$message.error(_this5.editData ? '编辑失败' : '新增失败');
                      case 10:
                        _context3.p = 10;
                        _this5.submitLoading = false;
                        return _context3.f(10);
                      case 11:
                        return _context3.a(2);
                    }
                  }, _callee3, null, [[4, 9, 10, 11]]);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 关闭弹框
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
      this.resetForm();
    }
  }
};